import { useEffect, useState } from 'react';

import { getCategories } from '../services/discover';

// Discover's category list (KPR-387), fetched once per mount. `[]` until it
// arrives and on a server without it: the callers fall back to free text
// then, which is what the field was before the list existed.
export default function useDiscoverCategories() {
	const [categories, setCategories] = useState([]);
	useEffect(() => {
		let live = true;
		getCategories().then(list => { if (live) setCategories(list); }).catch(() => {});
		return () => { live = false; };
	}, []);
	return categories;
}
